<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <section id="ngx-datatable-shipping">
            <div class="card">
                <div class="card-title d-flex justify-content-start align-items-center">
                    <button type="button" class="btn btn-icon btn-outline-primary" rippleEffect (click)="Back()">
                        <span [data-feather]="'arrow-left'"></span></button>
                    <h4 class="ml-50">{{isEditMode ? 'Editar' : 'Nuevo'}} Repartidor</h4>
                </div>
                <div class="card-title">
                    <form [formGroup]="dealerForm">
                        <div class="row">
                            <div class="form-group col-md-4">
                                <label class="form-label" for="vertical-name">
                                    <b class="text-primary">*</b> Nombre y Apellidos:
                                </label>
                                <input type="text" id="vertical-name" class="form-control" placeholder="Nombre"
                                    formControlName="name" />
                                <ngb-alert [type]="'danger'"
                                    *ngIf="fd.name.hasError('required') && (fd.name.touched || fd.name.dirty)"
                                    class="mt-1" [dismissible]="false">
                                    <div class="alert-body">
                                        <span [data-feather]="'info'" [class]="'mr-50 align-middle'"></span>
                                        <span>El nombre es requerido.</span>
                                    </div>
                                </ngb-alert>
                            </div>
                            <div class="form-group col-md-4">
                                <label class="form-label" for="vertical-username">
                                    <b class="text-primary">*</b> Usuario:
                                </label>
                                <input type="text" id="vertical-username" class="form-control" placeholder="Usuario"
                                    formControlName="userName" />
                                <ngb-alert [type]="'danger'"
                                    *ngIf="fd.userName.hasError('required') && (fd.userName.touched || fd.userName.dirty)"
                                    class="mt-1" [dismissible]="false">
                                    <div class="alert-body">
                                        <span [data-feather]="'info'" [class]="'mr-50 align-middle'"></span>
                                        <span>El usuario es requerido.</span>
                                    </div>
                                </ngb-alert>
                            </div>
                            <div class="form-group col-md-4">
                                <label class="form-label" for="vertical-password">
                                    <b class="text-primary">*</b> Contraseña:
                                </label>
                                <input type="password" id="vertical-password" class="form-control"
                                    placeholder="Contraseña" formControlName="password" />
                                <ngb-alert [type]="'danger'"
                                    *ngIf="fd.password.hasError('required') && (fd.password.touched || fd.password.dirty)"
                                    class="mt-1" [dismissible]="false">
                                    <div class="alert-body">
                                        <span [data-feather]="'info'" [class]="'mr-50 align-middle'"></span>
                                        <span>La contraseña es requerida.</span>
                                    </div>
                                </ngb-alert>
                            </div>
                            <div class="form-group col-md-4">
                                <label class="form-label" for="vertical-email">
                                    <b class="text-primary">*</b> Correo:
                                </label>
                                <input type="email" id="vertical-email" class="form-control" placeholder="Correo"
                                    formControlName="email" />
                                <ngb-alert [type]="'danger'"
                                    *ngIf="fd.email.hasError('required') && (fd.email.touched || fd.email.dirty)"
                                    class="mt-1" [dismissible]="false">
                                    <div class="alert-body">
                                        <span [data-feather]="'info'" [class]="'mr-50 align-middle'"></span>
                                        <span>El correo es requerido.</span>
                                    </div>
                                </ngb-alert>
                                <ngb-alert [type]="'danger'"
                                    *ngIf="fd.email.hasError('email') && (fd.email.touched || fd.email.dirty)"
                                    class="mt-1" [dismissible]="false">
                                    <div class="alert-body">
                                        <span [data-feather]="'info'" [class]="'mr-50 align-middle'"></span>
                                        <span>El correo no es correcto.</span>
                                    </div>
                                </ngb-alert>
                            </div>
                            <div class="form-group col-md-4">
                                <label class="form-label" for="vertical-phone">
                                    <b class="text-primary">*</b> Teléfono:
                                </label>
                                <input type="number" (keypress)="NumberOnly($event)" id="vertical-phone" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="10" class="form-control" placeholder="Teléfono"
                                    formControlName="phone" />
                                <ngb-alert [type]="'danger'"
                                    *ngIf="fd.phone.hasError('required') && (fd.phone.touched || fd.phone.dirty)"
                                    class="mt-1" [dismissible]="false">
                                    <div class="alert-body">
                                        <span [data-feather]="'info'" [class]="'mr-50 align-middle'"></span>
                                        <span>El Teléfono es requerido.</span>
                                    </div>
                                </ngb-alert>
                            </div>
                            <div class="form-group col-md-4">
                                <label class="form-label" for="vertical-address">
                                    <b class="text-primary">*</b> Dirección:
                                </label>
                                <input type="text" id="vertical-address" class="form-control" placeholder="Dirección"
                                    formControlName="address" />
                                <ngb-alert [type]="'danger'"
                                    *ngIf="fd.address.hasError('required') && (fd.address.touched || fd.address.dirty)"
                                    class="mt-1" [dismissible]="false">
                                    <div class="alert-body">
                                        <span [data-feather]="'info'" [class]="'mr-50 align-middle'"></span>
                                        <span>La Dirección es requerida.</span>
                                    </div>
                                </ngb-alert>
                            </div>
                            <div class="form-group col-md-4">
                                <label class="form-label" for="vertical-country">
                                    <b class="text-primary">*</b> Provincia:
                                </label>
                                <ng-select [items]="states" bindLabel="name" bindValue="id" formControlName="stateId"
                                    (change)="OnStateChange()">
                                </ng-select>
                            </div>
                            <div class="form-group col-md-4">
                                <label class="form-label" for="vertical-language">
                                    <b class="text-primary">*</b> Municipio:
                                </label>
                                <ng-select [items]="cities" bindLabel="name" bindValue="id" formControlName="cityId">
                                </ng-select>
                            </div>
                            <div class="form-group col-md-4">
                                <label class="form-label" for="vertical-language">
                                    <b class="text-primary">*</b> Rol:
                                </label>
                                <ng-select [items]="roles" bindLabel="name" bindValue="id" formControlName="roleId">
                                </ng-select>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="card-title d-flex justify-content-end align-items-center">
                    <button class="btn btn-danger mr-1" (click)="Cancel()" rippleEffect>
                        <i data-feather="delete" class="align-middle mr-sm-25 mr-0"></i>
                        <span class="align-middle d-sm-inline-block d-none">Cancelar</span>
                    </button>
                    <button class="btn btn-primary" (click)="Create()" rippleEffect
                        [disabled]="dealerForm.invalid">
                        <i data-feather="save" class="align-middle mr-sm-25 mr-0"></i>
                        <span class="align-middle d-sm-inline-block d-none">Guardar</span>
                    </button>
                </div>
            </div>
        </section>
    </div>
</div>